// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2eyuh","title":"Header_title__1PuLa","left":"Header_left__3FgDi","clinicName":"Header_clinicName__2UYWR"};